import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useScrollNavigationContext } from '../../../../hooks/useScrollNavigation/index.js';
import { Wrapper } from './styled.js';
export const VerticalNavigationGroupWrapper = memo(function VerticalNavigationGroupWrapper({ children }) {
    const { offset } = useScrollNavigationContext();
    return _jsx(Wrapper, { $offset: offset, children: children });
});
